module.exports = __webpack_public_path__ + "h5/img/bg.580e0ce6.jpg";